import { render, staticRenderFns } from "./WidgetUser.vue?vue&type=template&id=a7b12f42&"
import script from "./WidgetUser.vue?vue&type=script&lang=ts&"
export * from "./WidgetUser.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a7b12f42', component.options)
    } else {
      api.reload('a7b12f42', component.options)
    }
    module.hot.accept("./WidgetUser.vue?vue&type=template&id=a7b12f42&", function () {
      api.rerender('a7b12f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/WidgetUser.vue"
export default component.exports